import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, MousePointerClick, ListChecks, Users, Trophy } from "lucide-react";

const steps = [
  { icon: MousePointerClick, title: "Choose", body: "Two celebrities. One Smash Factor. Tap the one you'd pick." },
  { icon: ListChecks, title: "Explain", body: "Pick up to two reasons, one deciding factor, and how hard it was. This is where the game gets interesting." },
  { icon: Users, title: "Predict", body: "Guess what the majority will pick — and optionally the reason they'll give." },
  { icon: Trophy, title: "Reveal", body: "Get your archetype, prediction accuracy, and a shareable result card at the end of 5 rounds." },
];

export default function HowItWorks() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen spotlight grain scanlines">
      <div className="max-w-md mx-auto px-5 pt-6 pb-nav">
        <button data-testid="how-back-btn" onClick={() => nav(-1)} className="flex items-center gap-1 text-sm text-[#FDFBF7]/70 hover:text-[#FF107A]">
          <ArrowLeft size={16} /> Back
        </button>
        <h1 className="font-display text-5xl tracking-tight mt-4">HOW IT WORKS</h1>
        <p className="text-[#FDFBF7]/70 mt-2 text-sm">Four steps. Under five minutes.</p>

        <div className="mt-8 space-y-4">
          {steps.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              className="rounded-2xl border border-white/10 bg-[#16141D] p-4 flex gap-4"
            >
              <div className="shrink-0 w-11 h-11 rounded-xl bg-[#FF107A]/15 border border-[#FF107A]/30 flex items-center justify-center text-[#FF107A]">
                <s.icon size={20} />
              </div>
              <div className="min-w-0">
                <div className="flex items-baseline gap-2">
                  <span className="font-display text-2xl tracking-wide">{s.title}</span>
                  <span className="text-[10px] tracking-[0.25em] uppercase text-[#FDFBF7]/40">Step {i + 1}</span>
                </div>
                <p className="mt-1 text-sm text-[#FDFBF7]/75 leading-relaxed">{s.body}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <button
          data-testid="how-start-btn"
          onClick={() => nav("/daily")}
          className="mt-8 w-full rounded-full bg-[#FF107A] py-4 font-bold text-[#FDFBF7] glow-pink hover:brightness-110 transition-all"
        >
          Start today&rsquo;s smash
        </button>
      </div>
    </div>
  );
}
